package com.milta.feature.profile.presentation

sealed interface ProfileIntent {
    data object LoadProfile : ProfileIntent

    // Language
    data object OpenLanguageDialog : ProfileIntent
    data object DismissLanguageDialog : ProfileIntent
    data class SelectLanguage(val tag: String) : ProfileIntent
    data object ConfirmLanguageChange : ProfileIntent

    // Phone number
    data object OpenPhoneDialog : ProfileIntent
    data object DismissPhoneDialog : ProfileIntent
    data class PhoneDialCodeChanged(val value: String) : ProfileIntent
    data class PhoneLocalNumberChanged(val value: String) : ProfileIntent
    data object RequestPhoneChange : ProfileIntent
    data class OtpInputChanged(val value: String) : ProfileIntent
    data object ConfirmPhoneChange : ProfileIntent

    // Delete account
    data object OpenDeleteAccountDialog : ProfileIntent
    data object DismissDeleteAccountDialog : ProfileIntent
    data object RequestAccountDeletion : ProfileIntent
    data class DeleteOtpInputChanged(val value: String) : ProfileIntent
    data object ConfirmAccountDeletion : ProfileIntent

    data object CopyLinkedCode : ProfileIntent
    data object ClearError : ProfileIntent
    data object ClearSuccess : ProfileIntent
}
